import { getAccessibleContrastColor } from "./editions";

export default function initFooterNav(root = document) {
  root.querySelectorAll(".global-footer .site-menu__section, .global-footer__more").forEach(row => {
    const accent = getComputedStyle(row).getPropertyValue("--menu-section-accent").trim();
    row.style.setProperty("--footer-menu-contrast", getAccessibleContrastColor(accent || "#d3c8c0"));
  });
}
